import { Spacer } from '@lokalise/louis';
import { useEffect } from 'react';

import useDispatch from '@app/hooks/useDispatch';

import ProjectLayout from '../../components/ProjectLayout';
import { generateDownloadDataStoreState } from './__fixtures__/downloadData';
import { generateDownloadDataStoreStateExportConfig } from './__fixtures__/exportConfig';
import DownloadLimit from './components/DownloadLimit';
import DownloadPage from './components/DownloadPage';
import { downloadDataActions } from './reducers/downloadData/reducers';
import type {
    DataRange,
    EnabledTriggers,
    ExportEmptyOptions,
    ExportNullAsOptions,
    ExportSortOptions,
    FileFormatMapping,
    FileFormats,
    IntegrationsConfig,
    JavaPropertiesEncodingOptions,
    JavaPropertiesSeparatorOptions,
    ModuleProps,
    QaIssues,
    Repositories,
} from './types';

interface DownloadContainerProps {
    overLimit: boolean;
    canModifyBilling: boolean;
    props: ModuleProps;
    fileFormats: FileFormats;
    dataRange: DataRange;
    exportSortOptions: ExportSortOptions;
    exportEmptyOptions: ExportEmptyOptions;
    exportNullAsOptions: ExportNullAsOptions;
    javaPropertiesSeparatorOptions: JavaPropertiesSeparatorOptions;
    javaPropertiesEncodingOptions: JavaPropertiesEncodingOptions;
    enabledTriggers: EnabledTriggers;
    integrationsConfig: IntegrationsConfig;
    repositories: Repositories;
    projectBranchName: string | null;
    fileFormatMapping: FileFormatMapping;
    qaIssues: QaIssues;
}

const DownloadContainer = ({
    overLimit,
    canModifyBilling,
    props,
    fileFormats,
    dataRange,
    exportSortOptions,
    exportEmptyOptions,
    exportNullAsOptions,
    javaPropertiesSeparatorOptions,
    javaPropertiesEncodingOptions,
    enabledTriggers,
    integrationsConfig,
    repositories,
    projectBranchName,
    fileFormatMapping,
    qaIssues,
}: DownloadContainerProps) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            downloadDataActions.populateDownloadData({
                moduleProps: props,
                fileFormats,
                dataRange,
                exportSortOptions,
                exportEmptyOptions,
                exportNullAsOptions,
                javaPropertiesSeparatorOptions,
                javaPropertiesEncodingOptions,
                enabledTriggers,
                integrationsConfig,
                repositories,
                fileFormatMapping,
                projectBranchName,
                qaIssues,
            }),
        );
    }, [
        dispatch,
        props,
        fileFormats,
        dataRange,
        exportEmptyOptions,
        exportNullAsOptions,
        exportSortOptions,
        javaPropertiesSeparatorOptions,
        javaPropertiesEncodingOptions,
        enabledTriggers,
        integrationsConfig,
        repositories,
        fileFormatMapping,
        projectBranchName,
        qaIssues,
    ]);

    return (
        <ProjectLayout activeItem="download">
            <Spacer top={5}>
                {overLimit ? <DownloadLimit canModifyBilling={canModifyBilling} /> : <DownloadPage />}
            </Spacer>
        </ProjectLayout>
    );
};

export default DownloadContainer;

export { generateDownloadDataStoreState, generateDownloadDataStoreStateExportConfig };
